import { Fragment, type ReactNode } from 'react';

import { safeUrl } from '@/lib/forum';

/**
 * Renders untrusted Nostr text content safely:
 *  - React escapes all text (no innerHTML / dangerouslySetInnerHTML)
 *  - URLs are linkified only when they are http(s) (sanitized via safeUrl)
 */
export function PostBody({ content }: { content: string }) {
  return (
    <div className="whitespace-pre-wrap break-words text-[15px] leading-relaxed text-[#1a1a1a]">
      {linkify(content)}
    </div>
  );
}

function linkify(text: string): ReactNode[] {
  const parts = text.split(/(\s+)/);
  return parts.map((part, i) => {
    if (/^https?:\/\//i.test(part)) {
      const url = safeUrl(part);
      if (url) {
        return (
          <a
            key={i}
            href={url}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="text-[#105B86] underline hover:text-[#0d4f74]"
          >
            {part}
          </a>
        );
      }
    }
    return <Fragment key={i}>{part}</Fragment>;
  });
}
